import { makeQuery } from 'shared/utilities';
import { IWebResourceModel } from 'shared/models';

type ResponseType = {
    pages: number;
    items: IWebResourceModel[];
};

export const socialNetworksQuery = async function () {
    return await makeQuery<ResponseType>('/social-networks');
}
